import { Component, OnDestroy, OnInit,ViewChild, ElementRef } from '@angular/core';
import { LoginService } from '../login.service';
import { PatientsService } from '../patients.service';
import { Patient } from './patient';
import { ExamsService } from '../exams.service';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject, Subscription, timer } from 'rxjs';
import { pairwise, skip, switchMap, takeUntil } from 'rxjs/operators';
import { GastroFormsService } from '../gastro-forms.service';
import { GastroService } from '../gastro.service';
import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { WhatsappService } from '../whatsapp.service';
import { MessagesDialogComponent } from '../messages-dialog/messages-dialog.component';
import { msgAppAccessService } from '../msgappaccess.service';
import { pageCount, hasMorePages, shouldShowControls, resolveTotal, debouncedSearch } from '../pagination';
import { SPINNER_FADEOUT_DURATION } from '../app.constants';

@Component({
    selector: 'app-patients',
    templateUrl: './patients.component.html',
    styleUrls: ['./patients.component.scss'],
    standalone: false
})
export class PatientsComponent implements OnInit, OnDestroy {
  @ViewChild('swipeField') swipeField: ElementRef;
  showExcel = false
  showprintopts=false;
  showprint=false;
  inform = false;
  id: string;
  first: string
  last: string;
  phone: string
  idp = 1;
  showhelp: boolean = false;
  selectedPatient: Patient
  formSelected: any;
  invalidi: string = ""
  invalidf: string = ""
  invalidl: string = "";
  patList: Patient[];
  isAWL = false;
  AWLStatus = "Waiting";
  AWLExam="All"
  AWLlist: Patient[];
  examList;
  currentPage = 1;
  pageSize = 25;
  totalResults = 0;
  showPaginationControls = false;
  get totalPages(): number { return pageCount(this.totalResults, this.pageSize); }
  searchLoading = false;
  // Set true for the SPINNER_FADEOUT_DURATION window right before the loading flag clears, so the spinner fades out instead of popping away.
  searchFading = false;
  private searchTrigger$ = new Subject<string>();
  patientsearch = true;
  fromd: Date;
  tod: Date;
  openEsearch = false;
  isReports = false;
  hmostype;
  idfFormat: string = null; // this clinic's IDF file: 'legacy' txt or 'xlsx', which needs the invoice number
  idfInvoice = '';
  exams;
  typeForm
  examMode = 'All';
  examNames = ['1st', 'NT', 'Early', '2nd/3rd', 'Late', 'Specialized', 'Fetal Echo', 'Gynecology', 'Weight Assessment','Tech Exam','Emergency Room', 'Amniocentesis', 'CVS', 'Follicles'];
  examNamesGastro = ['Gastroscopy', 'Colonoscopy', 'Sigmoidoscopy'];

  lungsExamList = ["תפקודי ריאה"];
  echoExamList = ["אקו לב"];
  allCardioExamsList = [
    "אקו",
    "אקו ילדים",
    "אקו לב",
    "אקו מכבי",
    "אקו לאומית",
    "אקו מאוחדת",
    "אקו לב במאמץ",
    "אקו במאמץ מכבי",
    "אקו במאמץ לאומית",
    "אקו במאמץ מאוחדת",
    "אקו במאמץ פרטי",
    "ארגומטריה",
    "ארגומטריה מכבי",
    "ארגומטריה לאומית",
    "ארגומטריה מאוחדת",
    "הולטר קצב לב",
    "בדיקת אקג",
    "קרוטיד US עורקי צוואר",
    "ייעוץ קרדיולוגי",
    "יעוץ רפואי מכבי",
    "יעוץ רפואי לאומית",
    "יעוץ רפואי מאוחדת",
    "יעוץ רפואי כללית מושלם",
  ];
  reportsNames = ['Refferelnum', 'Macabi', 'HMO', 'AllReports','macabiList', 'Macabifin', 'NotSigned'];
  examVals = {};
  chosenAWL: number;
  awlTime: string;
  awlExamType: string;
  awlLMP;
  awlComment: string;
  prn: string;
  code: string;
  swiping=false;
  card: string;
  idcode:string;
  carderror:string;
  expcode:string;
  GA;
  GaArray: any[] = [];
  patExams: any[] = [];
  visitPat: any[] = [];
  showpayment: string;
  cardtzsearch: string;
  goEx = { preg: null, exam: null, etype: null }
  showLogin = false;
  startClinic: number;
  private destroy$ = new Subject();
  sub = new Subscription();
  startdate;
  enddate;
  changedExamCode;
  reportName=null;
  sentMacabi = false;
  openConcentForm;
  concentForm;
  last_search_time;
  toreassign;
  macabi2ndRun = false;
  macSearch = false;
  hasMessagingApp: boolean = false;
  messageCount$ = new BehaviorSubject<number>(0);
  isReportsLoading: boolean = false;
  isReportsFading: boolean = false;
  macabiMissing: false | 'codes' | 'refnum' = false;
  showSendQuestionnaire = false;
  sendQuestionnairePatient: any = null;
  patQuestionnaireAnswered: { [awlid: number]: boolean } = {};

  constructor(
    public gs: GastroService,
    public loginService: LoginService,
    public patservice: PatientsService,
    public whatsappService: WhatsappService,
    public msgAppAccessService: msgAppAccessService,
    public exServ: ExamsService,
    private rt: Router,
    public gfs: GastroFormsService,
    private datePipe: DatePipe,
    private http: HttpClient
  ) {
    this.id = ""
    this.first = ""
    this.last = ""
    this.phone = ""
    if(loginService.isCardio){
      this.examNames = ['TTE Adults','TTE Pediatric', 'Stress-Echo','Duplex Carotid','ECG','Ergometry', 'Stress', 'Holter ECG','Pulmonary functional assessment','Methacholine test']
    }
    for (let e of this.examNames)
      this.examVals[e] = true;
  }

  clear() {
    this.id = ""
    this.first = ""
    this.last = ""
    this.phone = ""
    if (this.isAWL)
      this.search();
  }

  ngOnInit() {
    debouncedSearch(this.searchTrigger$)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.runSearch());
    let now = new Date();
    let ndate = now.getFullYear() + '-' + (now.getMonth() + 1 < 10 ? '0' : '') + (now.getMonth() + 1) + '-' + (now.getDate() < 10 ? '0' : '') + now.getDate();
    now = new Date(ndate);
    this.tod = now;
    this.fromd = now;
    this.getPermissions();
    this.loginService.loginMissing();
    if (this.loginService.showAWL()) {
      if (this.loginService.lastAwl) {
        this.AWLStatus = this.loginService.lastAwl
      }
      if(this.loginService.lastAwlExam)
        this.AWLExam = this.loginService.lastAwlExam
      if(this.loginService.lastAwlStartDate && this.loginService.lastAwlEnDate){
        this.startdate = this.loginService.lastAwlStartDate;
        this.enddate = this.loginService.lastAwlEnDate;

      }
      if(this.loginService.isCardio){
        switch (this.loginService.userType) {
          case 'doctor':
            this.AWLStatus = "Completed"
            
            break;
          case 'tech':
            this.AWLStatus = "Received"
            
            break;
        
          default:
            this.AWLStatus = "Waiting"
            break;
        }
      }
      if(!this.exServ.searchReport)
        this.AWL();
    }
    this.loginService.onLogin.pipe(takeUntil(this.destroy$)).subscribe(() => {
      if ((this.goEx.preg && this.goEx.exam && this.goEx.etype) || (this.goEx &&(this.loginService.isGastro || this.loginService.isCardio))) {
        this.exServ.goExam(this.goEx.preg, this.goEx.exam, this.goEx.etype);
      }

    });
    this.patservice.exitFromGastroExam.subscribe(() => {
      this.AWLStatus = this.patservice.AWLStatus;
      this.loginService.lastAwl = "All";
    });
    this.patservice.awlIncomming.pipe(takeUntil(this.destroy$)).subscribe(()=>{
      if(this.isAWL)
        this.AWL();
    });
    if(this.exServ.searchReport){
      this.fromd=this.exServ.searchReport.start;
      this.tod=this.exServ.searchReport.end;
      this.reportName=this.exServ.searchReport.type;
      this.hmostype=this.exServ.searchReport.hmo;
      this.isReports = true;
      this.AWLlist = null;
      this.searchClosed([this.fromd, this.tod, [], this.reportName, this.hmostype])
      // this.examSearch(this.reportName, this.hmostype);

    }

  }

  addPatient() {
    this.invalidi = "";
    if (this.id.length < 7) {
      this.invalidi = "is-invalid";
      return;
    }
    this.invalidf = ""
    if (this.first == "") {
      this.invalidf = "is-invalid";
      return
    }
    this.invalidl = "";
    if (this.last == "") {
      this.invalidl = "is-invalid";
      return
    }
    this.selectedPatient = new Patient(this.id, this.first, this.last, this.phone);

  }

  onClosed(closed: string) {
    if (closed)
      this.selectedPatient = null
    if (closed == 'awl') {
      this.clear();
      this.AWL();
    }
    else
      if (this.patList)
        this.search();//to refresh details
    this.awlExamType = null;
    this.awlLMP = null;
    this.awlTime = null;
    this.chosenAWL = null;
    this.prn = null;
    this.code = null;
    this.typeForm = null;

  }

  search(noawl = false) {
    this.examList = null;
    this.exServ.searchReport = null;
    this.isReports = false;
      this.carderror = null;
      if (this.isAWL && !noawl) {
        this.patList = null;
        this.searchLoading = true;
        if(this.startdate, this.enddate){
          var start = (this.startdate._i.year)+'-' + (this.startdate._i.month +1) + '-' +this.startdate._i.date + ' 00:00:00.000' 
          var end = (this.enddate._i.year)+'-' + (this.enddate._i.month +1) + '-' + this.enddate._i.date  + ' 23:59:59.000'
        }
        this.patservice.getAWL(this.AWLStatus, this.AWLExam,{ 'id': this.id, first: this.first, last: this.last, start:start, end: end, uid:this.loginService.doctor,RID:this.loginService.room }).subscribe((patients: Patient[]) => {
          if (patients.length > 0) {
            this.GaArray = [];
            patients.forEach((i) => {
              var GAitem = this.lmpGA(i.ExamLMP);
              this.GaArray.push(GAitem);
              if(i.UID)
                i['nUID'] = i.UID;
            })
          }
          this.searchFading = true;
          setTimeout(() => { this.searchLoading = false; this.searchFading = false; }, SPINNER_FADEOUT_DURATION);
          this.AWLlist = patients;
          this.loadQuestionnaireStatuses(patients);
          if(this.cardtzsearch){
            this.swiping = false;
            for(let pat of this.AWLlist){
              let zeros = pat.ID
              while(zeros.length < 9)
                zeros = '0'+ zeros;
              if(pat.ID == this.cardtzsearch || zeros == this.cardtzsearch){
                this.setAWL(pat);
                this.selectedPatient=pat;
                if(this.selectedPatient.HMO != "Macabi"){//now for macabi only
                  this.selectedPatient.HMO = 'Macabi';
                  this.patservice.savePatient(this.selectedPatient,this.selectedPatient.PID).subscribe((data) => {
                  },(error)=>{
                    this.carderror = this.cardtzsearch;
                    console.log(error);
                  });
                }
                this.showpayment = this.cardtzsearch;
                this.cardtzsearch = null;
                this.macabi2ndRun = false;
              }
            }
            if(this.cardtzsearch){
              if(this.loginService.hasPremission('MacabiFillPatient') && ! this.macabi2ndRun){
                this.swiping = true;
                this.macSearch = true;
                const timer = setTimeout(() => {
                  this.cancelSearch();
                }, 60000);
                this.patservice.macabiAdd(this.cardtzsearch,this.idcode,this.expcode,this.loginService.macabiUnit).subscribe((data)=>{
                  this.macSearch = false;
                  this.swiping = false;
                  clearTimeout(timer);
                  if(data['status'] == 'ok'){
                    this.macabi2ndRun = true;
                    this.search();
                  }else{
                   this.carderror = data['status'];
                  }
                },(error)=>{
                  clearTimeout(timer);
                  this.carderror = 'Error on Maccabi lookup';
                  this.cancelSearch();
                })
              }
              else{
                this.carderror = this.cardtzsearch;
                this.cardtzsearch = null;
                this.macabi2ndRun = false;
              }
            }
           
          }
          
        }, (error) => {
          this.searchFading = true;
          setTimeout(() => { this.searchLoading = false; this.searchFading = false; }, SPINNER_FADEOUT_DURATION);
          console.log(error)
        });
      }
      else {
        this.AWLlist = null;
        // this.visitPat = null;
        this.searchLoading = true;
        this.patservice.getPatients(this.id, this.first, this.last, this.phone, this.loginService.doctor, (patients: Patient[]) => {
          this.patList = [];
          this.isAWL = false;
          for (let i = 0; i < patients.length; i++) {
            let pat = new Patient()
            pat.asignVals(patients[i])
            this.patList[i] = pat
          }
          this.totalResults = resolveTotal(patients as any);
          this.showPaginationControls = shouldShowControls(this.totalResults, this.pageSize);
          this.searchFading = true;
          setTimeout(() => { this.searchLoading = false; this.searchFading = false; }, SPINNER_FADEOUT_DURATION);
        }, this.currentPage, this.pageSize,
          () => {
            // A failed request must still clear the spinner, or it spins forever.
            this.searchFading = true;
            setTimeout(() => {
              this.searchLoading = false;
              this.searchFading = false;
            }, SPINNER_FADEOUT_DURATION);
          }
        );
      }
    // }
  }

  cancelSearch(){
    this.macSearch = false;
    this.swiping = false;
  }

  nextPatPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.search();
    }
  }

  prevPatPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.search();
    }
  }

  // A fresh search always starts on page 1.
  private resetPaging() {
    this.currentPage = 1;
  }

  trysearch() {
    this.id = this.id.replace(/\-/g, '_').replace(/\W/g, '').replace(/_/g, '-');
    this.resetPaging();
    this.searchTrigger$.next(`${this.id}|${this.first}|${this.last}|${this.phone}`);
  }

  // Immediate search from the Search button: same page reset as typing, but no
  // debounce and no distinct gate so re-clicking the same query always re-fires.
  searchNow() {
    this.resetPaging();
    this.search(true);
  }

  private runSearch() {
    if (!this.isSearchDisabled())
      this.search(!this.loginService.ishospital);//for clinics search works on patients - not awl
    if (this.isAWL && this.id.length == 0 && this.first.length == 0 && this.last.length == 0)//when cleared
      this.search();
  }

  // Button gate: the content rule plus an in-flight check, so the button can't be spammed while a search is pending.
  // Kept separate from isSearchDisabled() so a request in flight never blocks the debounced auto-search.
  get isSearchButtonDisabled(): boolean {
    return this.searchLoading || this.isSearchDisabled();
  }

  isSearchDisabled(): boolean {
    return !(
      this.id.trim().length > 1 ||
      this.first.trim().length > 1 ||
      this.last.trim().length > 1 ||
      this.phone.trim().length > 1
    );
  }

  AWL(savestatus=true, type=null) {
    if(! this.enddate && this.startdate){
      this.enddate = this.startdate
    }else if(! this.startdate && this.enddate){
      this.startdate = this.enddate 
    }
    if(savestatus){
      this.loginService.lastAwlExam = this.AWLExam;
      this.loginService.lastAwl = this.AWLStatus;
      this.loginService.lastAwlStartDate = this.startdate;
      this.loginService.lastAwlEnDate = this.enddate;

    }
    this.isAWL = true;
    this.examList = null;
    this.exServ.searchReport = null;
    this.search();
    this.patservice.openWebSocket(! this.loginService.ishospital? this.loginService.ClinicID: null);
  }

  switchSearch() {
    this.patientsearch = !this.patientsearch;
    if (!this.patientsearch)
      this.examSearch();
    else
      this.examList = [];
  }

  examSearch(reportName = null, hmo = null) {
    this.isAWL = false;
    this.AWLlist = null;
    this.visitPat = null
    this.patList = null;
    this.isReportsLoading = true;
    if(reportName){
      this.isReports = true;
      this.reportName = reportName;
      this.hmostype = hmo;
      if(hmo == 'IDF' && this.idfFormat === null)
        this.http.get('/api/cardio/idf/format').subscribe((data: any) => this.idfFormat = data.format);
      this.exServ.searchReport = {start:this.fromd, end:this.tod, type:reportName, hmo:hmo}
      this.exServ.reportSearch(this.fromd, this.tod, reportName, hmo, this.loginService.doctor, this.macabiMissing).subscribe((data) => {
        this.examList = data;
        this.isReportsFading = true;
        setTimeout(() => { this.isReportsLoading = false; this.isReportsFading = false; }, SPINNER_FADEOUT_DURATION);
      }, (error) => {
        console.log(error);
        this.isReportsFading = true;
        setTimeout(() => { this.isReportsLoading = false; this.isReportsFading = false; }, SPINNER_FADEOUT_DURATION);
      })
    }else{
      this.exServ.searchReport = null;
      this.isReports = false;
      this.exServ.examSearch(this.fromd, this.tod, this.examVals, this.loginService.doctor).subscribe((data) => {
        this.examList = data;
        this.isReportsFading = true;
        setTimeout(() => { this.isReportsLoading = false; this.isReportsFading = false; }, SPINNER_FADEOUT_DURATION);
      }, (error) => {
        console.log(error);
        this.isReportsFading = true;
        setTimeout(() => { this.isReportsLoading = false; this.isReportsFading = false; }, SPINNER_FADEOUT_DURATION);
      })
    }
  }

  goPatient(pid: number) {
    this.patservice.getPatient(pid, (s) => {
      if (s)
        this.rt.navigate(['/exams'], { state: { data: this.patservice.currentPatient } });
    });

  }

  getLocked(exam) {
    var now = new Date();
    var lockedTime = new Date(exam.Locked);
    var lock = true;
    if (now.getDate() !=  lockedTime.getDate() ||  now.getMonth() != lockedTime.getMonth() || now.getFullYear() != lockedTime.getFullYear() || (now.getHours() - lockedTime.getHours()) > 1) {
     lock = false;
    }
    if ((exam.Locked || lock) && exam.LockedBy && !this.loginService.isAdmin)
      return 'locked';
    return 'unlocked';
  }

  viewonly() {
    this.exServ.goExam(this.goEx.preg, this.goEx.exam, this.goEx.etype, true);
  }

  goExam(exam/*PID: number, examID: number, PregIndex: number, etype: string,examtime: string*/) {
    let preg = exam.PregIndex ? { AutoIndex: exam.PregIndex } : null;
    let id = exam.AutoIndex;
    this.patservice.getPatient(exam.PID, (s) => {
      if (s) {
        if (exam.Locked && exam.LockedBy && !this.loginService.isAdmin)
          return;
        let etime = new Date(exam.CreationTime);
        let now = new Date();
        if (exam.ExamType != 'Emergency Room' && ((! this.exServ.examClosed(etime) && !this.loginService.isCardio) || (this.loginService.isCardio && !exam.ClosedDate)) && (this.loginService.userType == 'doctor' || this.loginService.userType == 'visitingdoc' || this.loginService.userType == 'tech')) {
          this.exServ.examObject = exam;
          this.showLogin = true;

          this.goEx = { preg: preg, exam: exam, etype: exam.ExamType };
          if (this.loginService.ClinicID)
            this.startClinic = this.loginService.ClinicID;
        }
        else

          this.exServ.goExam(preg, exam, exam.ExamType, s.PID);
      }
    });
  }
  searchClosed($event: any[]) {
    this.macabiMissing = false;
    this.showExcel = true;
    if ($event && $event.length > 3) {
      this.fromd = $event[0];
      this.tod = $event[1];
      if(this.reportsNames.includes($event[3])){
        this.examSearch($event[3],$event[4]);
      }else{
        this.examVals = $event[2];
        this.examMode = $event[3];
        this.examSearch();
      }
    }
    this.openEsearch = false;

  }

  setAWL(pat) {
    if (pat.Status == 'Waiting' || (pat.Status == 'Received' && this.loginService.hasPremission('MacabiFillPatient'))) {
      try {
        let edate = new Date(pat.ExamDate)
        this.awlTime = edate.getHours() + ':' + (edate.getMinutes() < 10 ? '0' : '') + edate.getMinutes();
      }
      catch {
        this.awlTime = null;
      }
      this.awlExamType = pat.ExamCode;
      
      this.awlLMP = pat.ExamLMP;
      this.awlComment = pat.Reason ? pat.Reason : null;
    }
    this.chosenAWL = pat.AWLID;
  }
  lmpGA(lmp) {
    if (!lmp)
      return "";
    let dt = new Date();
    let days = Math.floor((dt.getTime() - Date.parse(lmp)) / (1000 * 60 * 60 * 24));
    return Math.floor(days / 7) + "w " + (Math.floor(days) % 7) + "d"
  }

  saveComment(comment: string, AWLID: number) {
    this.patservice.saveAWLComment(comment, AWLID);
  }

  getcard(){
    this.card='';
    this.id='';
    this.cardtzsearch='';
    setTimeout(()=> {this.swipeField.nativeElement.focus();},100);
  }

  getTZ(){//macabi
    this.cardtzsearch=this.id;
    this.idcode='0';
    this.expcode='0';
    if(this.AWLStatus != 'All')
        this.AWLStatus = 'All';
      this.AWL(false);
  }

  proccesscard(evt){
    evt = evt || window.event;
    var isEscape = false;
    if ("key" in evt) 
        isEscape = (evt.key === "Escape" || evt.key === "Esc");
    else 
        isEscape = (evt.keyCode === 27);
    
    if (isEscape)
      this.swiping=false;
    var card = this.card;
    if(this.card && this.card.length > 26 && this.card.includes('8=47'))//8=47 is the start of a macabi card
      card = this.card.substring(this.card.indexOf('8=47'));
    if(card && card.length > 26 && ! this.cardtzsearch && ! this.showpayment){
      this.cardtzsearch = card.substring(7,16);
      this.idcode = card.substring(6,7);
      this.expcode = card.substring(16,20);
      if(this.AWLStatus != 'All')
        this.AWLStatus = 'All';
      this.AWL(false);
    }
  }
  macCheck(){
    this.swiping = false;
    this.cardtzsearch = this.card;
    if(this.AWLStatus != 'All')
        this.AWLStatus = 'All';
      this.AWL(false);
  }

  barscan(evt){
    evt = evt || window.event;
    var isEscape = false;
    if ("key" in evt) 
        isEscape = (evt.key === "Escape" || evt.key === "Esc");
    else 
        isEscape = (evt.keyCode === 27);
    
    if (isEscape)
      this.swiping=false;
    
    if(this.card.trim().length >= 12 && (! this.last_search_time || Date.now() > this.last_search_time + 5000)){//belinson addmission code
      this.last_search_time = Date.now();
       this.patservice.findPatBelinson(this.card.trim()).subscribe( (patient: Patient) => {
         if(patient){
          this.patList = [];
           this.isAWL = false;
           let pat = new Patient()
           pat.asignVals(patient)
           this.patList[0] = pat;
            this.setAWL(pat);
           this.selectedPatient=pat;
           this.swiping = false;
           this.card = '';
           this.awlTime = new Date().toTimeString().substring(0,5);
         }
        
       },(err)=> {
        console.log(err)
      });
    }
  }

  paymentNoCard(){
    this.showpayment = this.selectedPatient.ID;
    while(this.showpayment.length < 9)
      this.showpayment = '0' + this.showpayment.toString();
    this.idcode = '0';
    this.expcode = null;
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
    this.destroy$.next(undefined);
    this.destroy$.complete();
    this.patservice.closeWebSocket();
  }

  getStatus(status: string):string{//for cardio
    if(this.loginService.isCardio){
      switch(status){
        case 'Completed':
          return 'Performed';
        case 'Waiting':
          return 'Scheduled';
        case 'Received':
          return 'Waiting';
        default:
          return status;
      }
    }
    else
      return status;
  }

  setExamCode(pat){
    var saveTitle = this.patservice.setExamCode(this.changedExamCode, pat.AWLID);
    saveTitle.subscribe((res) =>{
      console.log(res);
      this.changedExamCode = null;
      this.AWL()
    })
  }

  setPatAwlid(pat){
    if(this.loginService.isGastro){
      this.gfs.paitentLoaded$.next(pat);
    }
  }

  filterExams(exams, type, hmo = null){
    if (!exams) return [];
    if(hmo)
      return exams.filter((i) => i.ExamType == type && (i.HMO == hmo && i.PRN))
    return exams.filter((i) => i.ExamType == type)
  }

  // Helper method to build Macabi codes and prices string with total
  getMacabiCodesPricesString(exam: any): { codesDisplay: string; totalPrice: string } {
    if (!exam.HMOExamCode || !exam.MacabiPrices) {
      return { codesDisplay: '', totalPrice: '' };
    }

    try {
      let codes = exam.HMOExamCode.split(',').map((c: string) => c.trim()).filter((c: string) => c);
      let prices = JSON.parse(exam.MacabiPrices);

      let codesPricePairs: string[] = [];
      let totalPrice = 0;

      for (let code of codes) {
        let price = prices[code];
        if (price) {
          let priceNum = parseFloat(price);
          totalPrice += priceNum;
          codesPricePairs.push(`${code}: ${parseInt(price || '0')}.${(price || '').split('.')[1] || '00'}`);
        } else {
          codesPricePairs.push(code);
        }
      }

      let codesDisplay = codesPricePairs.join(', ');
      return {
        codesDisplay: codesDisplay,
        totalPrice: totalPrice.toFixed(2)
      };
    } catch (e) {
      return { codesDisplay: '', totalPrice: '' };
    }
  }

  export(){
    if(this.reportName == 'Macabifin'){
      this.veiwMacabi();
      return;
    }
    var table;
    var strTable;
    var items =['CreationTime','ID', 'First', 'Last', 'HMO', 'ExamType']
    
    // Check if this is a Macabi report with prices
    const hasPrices = this.reportName == 'Macabi' && this.examList.some(exam => exam.Price);
    if(hasPrices){
      items.push('Price');
    }
    
    if(this.loginService.hasPremission('NoExams'))
      items = ['CreationTime','ID', 'First', 'Last', 'PatPayment','CollectAtClinic'];
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    strTable = '<tr>'
    if(! this.loginService.hasPremission('NoExams'))
      strTable += '<td> חיפוש לפי</td><td>'+this.getType(this.exServ.searchReport.type)+'</td><td>'+this.getHMO(this.exServ.searchReport.hmo)+'</td>'
    else
      strTable += '<td> חיפוש לפי</td><td>מבכי זכאות</td>'
    strTable +='</tr><tr></tr>'
    strTable +='<tr><td>תאריכים</td><td>'+this.getDate(this.exServ.searchReport.start)+'</td><td>'+this.getDate(this.exServ.searchReport.end)+'</td></tr>'

    if(this.examList.length > 0){
      if(! this.loginService.hasPremission('NoExams')){
        let allExamsTotal = 0;
        let allPriceTotal = 0;
        
        for(let name of this.examNames){
          const filteredExams = this.filterExams(this.examList, name);
          if(filteredExams.length == 0) continue;
          
          // Calculate totals for this exam type
          let examCount = filteredExams.length;
          let priceTotal = 0;
          if(hasPrices){
            priceTotal = filteredExams.reduce((sum, exam) => sum + (parseFloat(exam.Price) || 0), 0);
            allExamsTotal += examCount;
            allPriceTotal += priceTotal;
          }
          
          var examTable ='';
          examTable +='<tr>';
          table = document.createElement('table');
          examTable +=`<td>${name}</td>`
          examTable +='</tr>'
          
          // Add summary row for this exam type
          if(hasPrices){
            examTable +='<tr>';
            examTable +=`<td colspan="2"><strong>סה"כ בדיקות:</strong></td><td><strong>${examCount}</strong></td>`;
            examTable +=`<td colspan="2"><strong>סה"כ מחיר:</strong></td><td><strong>${priceTotal.toFixed(2)}</strong></td>`;
            examTable +='</tr><tr></tr>';
          }
          
          examTable +='<tr>';
          for(let item of items){
            examTable +=`<td><strong>${item}</strong></td>`
          }
          examTable +='</tr>'
          examTable +='<tr>';
          for(let exam of filteredExams){

            for(let item of items){
              var date;
              if(item == 'CreationTime'){
                date = exam[item].replace('T', ' ').replace('Z', '')
                examTable +=`<td>${date}</td>`
              }else if(item == 'Price'){
                examTable +=`<td>${exam[item] || '0'}</td>`
              }else{
                examTable +=`<td>${exam[item] || ''}</td>`
              }

            }
            examTable +='</tr>'

          }
          
          table.innerHTML = strTable +examTable;
          const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);
          XLSX.utils.book_append_sheet(wb, ws, name);
        }
        
        // Add summary sheet for all exam types
        if(hasPrices && allExamsTotal > 0){
          var summaryTable = '';
          summaryTable +='<tr>';
          table = document.createElement('table');
          summaryTable +=`<td><strong>סיכום כללי - כל הבדיקות</strong></td>`
          summaryTable +='</tr><tr></tr>'
          summaryTable +='<tr>';
          summaryTable +=`<td><strong>סה"כ בדיקות מכל הסוגים:</strong></td><td><strong>${allExamsTotal}</strong></td>`;
          summaryTable +='</tr>';
          summaryTable +='<tr>';
          summaryTable +=`<td><strong>סה"כ מחיר מכל הסוגים:</strong></td><td><strong>${allPriceTotal.toFixed(2)}</strong></td>`;
          summaryTable +='</tr><tr></tr>';
          
          // Add breakdown by exam type
          summaryTable +='<tr><td colspan="2"><strong>פירוט לפי סוג בדיקה:</strong></td></tr>';
          summaryTable +='<tr><td><strong>סוג בדיקה</strong></td><td><strong>כמות</strong></td><td><strong>מחיר</strong></td></tr>';
          
          for(let name of this.examNames){
            const filteredExams = this.filterExams(this.examList, name);
            if(filteredExams.length > 0){
              let examCount = filteredExams.length;
              let priceTotal = filteredExams.reduce((sum, exam) => sum + (parseFloat(exam.Price) || 0), 0);
              summaryTable +='<tr>';
              summaryTable +=`<td>${name}</td><td>${examCount}</td><td>${priceTotal.toFixed(2)}</td>`;
              summaryTable +='</tr>';
            }
          }
          
          table.innerHTML = strTable + summaryTable;
          const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);
          XLSX.utils.book_append_sheet(wb, ws, 'סיכום כללי');
        }
      }else{//macabi zakaut list
        var examTable ='';
          examTable +='<tr>';
          table = document.createElement('table');
          examTable +=`<td>${name}</td>`
          examTable +='</tr>'
          examTable +='<tr>';
          for(let item of items){
            examTable +=`<td><strong>${item}</strong></td>`
          }
          examTable +='</tr>'
          examTable +='<tr>';
          for(let exam of this.examList){
            for(let item of items){
              var date;
              if(item == 'CreationTime'){
                date = exam[item].replace('T', ' ').replace('Z', '')
                examTable +=`<td>${date}</td>`
              }else{
                examTable +=`<td>${exam[item]}</td>`
              }
            }
            examTable +='</tr>'
          }
          
          table.innerHTML = strTable +examTable;
          if(this.examList.length > 0){
            const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);
            XLSX.utils.book_append_sheet(wb, ws, 'maccabi');
          }
        
      }
      XLSX.writeFile(wb, new Date().toISOString().split('T')[0]+'.xlsx');
      this.loginService.exportLoading = false;
      this.showLogin = false;
      this.sub.unsubscribe();
    }
  }

  sendMacabi(){
      let formatDate = (d: any) => {
        if (d instanceof Date) {
          let year = d.getFullYear();
          let month = d.getMonth() + 1;
          let day = d.getDate();
          return year + '-' + (month < 10 ? '0' : '') + month + '-' + (day < 10 ? '0' : '') + day;
        } else if (d && d._i) {
          let month = d._i.month + 1;
          let day = d._i.date;
          return d._i.year + '-' + (month < 10 ? '0' : '') + month + '-' + (day < 10 ? '0' : '') + day;
        }
        return '';
      };
      this.patservice.sendMacabi(formatDate(this.fromd), formatDate(this.tod)).subscribe((data)=>{
        this.sentMacabi = true;
      },(err)=>{
        console.log(err);
      });
    
  }

  veiwMacabi(){
    // Support both moment-like and Date objects
    let formatDate = (d: any) => {
      if (d instanceof Date) {
        let year = d.getFullYear();
        let month = d.getMonth() + 1;
        let day = d.getDate();
        return year + '-' + (month < 10 ? '0' : '') + month + '-' + (day < 10 ? '0' : '') + day;
      } else if (d && d._i) {
        let year = d._i.year;
        let month = d._i.month + 1;
        let day = d._i.date;
        return year + '-' + (month < 10 ? '0' : '') + month + '-' + (day < 10 ? '0' : '') + day;
      }
      return '';
    };
    this.patservice.getMacabiReprt(formatDate(this.fromd), formatDate(this.tod));
  }

  getHMO(hmo){
    switch (hmo) {
      case 'Macabi':
        return 'מכבי';
      case 'Leumit':
        return 'לאומית';
      case 'Meuhedet':
        return 'מאוחדת';
      case 'Clalit':
        return 'כללית';
      case 'Private':
        return 'פרטי';
      case 'IDF':
        return 'צהל';
      case 'null':
        return 'לא שוייכו';
      default:
        return "הכל"
    }
  }
  getType(type){
    
    switch (type) {
      case 'Macabi':
        return 'בדיקות שנשלחו למכבי'
      case 'HMO':
        return 'קופת חולים'
      case 'Refferelnum':
        return "מס' הפניה חסר"
      case 'NotSigned':
        return 'בדיקות לא חתומות'
      default:
        return "הכל"
    }
  }
  getDate(date){
    var temp = new Date(date)
    var str = temp.getDate()+'/'+(temp.getMonth()+1)+'/'+temp.getFullYear()
    return str
  }

  startForm(pat) {
    this.exServ.patServ.setPat(pat);
    this.exServ.concentForm = null;
    var res = this.exServ.getConcentForms(pat.PID);
    res.subscribe((data:any) =>{
      console.log(data);
      if(!data.hasOwnProperty("empty")){

        var temp = data.filter((i) => i.ExamType == pat.ExamCode && !i.ExamID)
        if(pat.ExamCode.split(" ")[1] == 'Anatomy' || pat.ExamCode.split(" ")[1] == 'Trimester' )
        var temp = data.filter((i) => i.ExamType == pat.ExamCode.split(" ")[0] && !i.ExamID)
        if(temp.length > 0){
          this.concentForm = temp[0]
        }else{
          this.exServ.concentForm = null
          this.exServ.examID = null;
          this.exServ.pregId = null;
          this.exServ.pregnancies = null;
          this.concentForm = null;
        }
      }else{
        this.exServ.examID = null;
        this.exServ.pregId = null;
        this.exServ.pregnancies = null;
        this.exServ.concentForm = null
        this.concentForm = null;
      }
      this.inform =true;
    })
  }
  getDoctors(){
    return this.loginService.clinicUsers
  }

  openSendQuestionnaire(pat: any) {
    this.sendQuestionnairePatient = pat;
    this.showSendQuestionnaire = true;
  }

  // AR-24: green check badge on the today-list questionnaire icon when answered.
  private loadQuestionnaireStatuses(patients: any[]): void {
    if (!this.loginService.hasPremission('Questionnaires')) return;
    this.patQuestionnaireAnswered = {};
    for (const pat of patients) {
      if (!pat?.PID || !pat?.AWLID) continue;
      this.exServ.getPatientQuestionnaires(pat.PID).subscribe((data: any) => {
        const items = (data && data.items) || [];
        const answered = items.some((i: any) => i.answeredDate && (!pat.ExamCode || i.examCode === pat.ExamCode));
        if (answered) this.patQuestionnaireAnswered[pat.AWLID] = true;
      });
    }
  }

  /*reassign(){//move pat and todaylist to another doctor
    this.toreassign.UID = this.toreassign.nUID;
    this.toreassign.nUid = this.toreassign.UID;
    this.patservice.reassign(this.toreassign).subscribe((data)=>{
      this.toreassign = null;
      this.AWL();
    },(error)=>{
      this.toreassign = null;
      this.AWL();
      console.log(error)
    })
  } *///geting rid of this


  closCalForm(event){
    this.inform = false;
  }

  getDbName(i,str){
    var t = i.replace("-", "").split(" ")[0]

    return str+t
  }

  getIDF(){
    let url = '/api/cardio/idf/'+ this.datePipe.transform(this.fromd,'yyyy-MM-dd') +'/' + this.datePipe.transform(this.tod,'yyyy-MM-dd');
    if(this.idfFormat == 'xlsx')
      url += '?invoice=' + encodeURIComponent(this.idfInvoice.trim());
    window.open(url);
  }

  redirectAdministration(type) {
    this.http
      .post("/api/administration", { type })
      .subscribe((data: string) => {
        window.location.href = data;
      });
  }
  openMsgApp() {
    this.msgAppAccessService.open(MessagesDialogComponent, {
      width: '80vw',
      height: '85vh',
      panelClass: 'iframe-dialog',
      hasBackdrop: false,
    });
  }
  restoreDialog(): void {
    this.msgAppAccessService.restore();
  }
  private playSound(): void {
    const audio = new Audio('assets/sounds/bell.mp3');
    audio.play();
  }
  async getPermissions() {
    try {
      const getPerm = await this.http.get('/api/whatsapp/hasMessaging').toPromise();
      
      if (getPerm === true) {
        this.hasMessagingApp = true;
        this.startMessagePolling();
      } else {
        this.hasMessagingApp = false;
      }
    } catch (err) {
      console.error('Failed to get messaging permissions', err);
      this.hasMessagingApp = false;
    }
  }
  startMessagePolling() {
    timer(0, 2 * 60 * 1000)
    .pipe(
      switchMap(() => this.whatsappService.getAwaitingMsg()),
      takeUntil(this.destroy$)
    )
    .subscribe(
      (response:any) => {
        // 2. Push the new count into the stream
        this.messageCount$.next(response.MsgCount);
      },
      (error) => {
        console.error('Failed to get message count', error);
        this.messageCount$.next(0); // Push 0 on error
      }
    );
  // 3. This stream LISTENS for changes and plays the sound
  this.messageCount$
    .pipe(
      pairwise(), // Emits the [previous, current] value. Skips the first emission!
      skip(1),
      takeUntil(this.destroy$)
    )
    .subscribe(([previousCount, currentCount]) => {
      if (currentCount > previousCount) {
        this.playSound();
      }
    });
  }
  
  getTodayListExamTypes() {
    if (this.loginService.ClinicID === 150) {
      // שרן קרדיולוגיה
      return this.echoExamList;
    }
    if (
      this.loginService.hasPremission("Pneumology") ||
      this.loginService.hasPremission("Methacholine")
    ) {
      const examList = [];
      if (this.loginService.hasPremission("Pneumology")) {
        examList.push("תפקודי ריאה");
      }
      if (this.loginService.hasPremission("Methacholine")) {
        examList.push("בדיקת תגר מטכולין");
      }
      if (this.loginService.hasPremission("Pneumology") && this.loginService.hasPremission("Methacholine")) {
        examList.push("תפקודי ריאה+בדיקת תגר מטכולין");
      }
      return examList;
    }
    return this.allCardioExamsList;
  }
}
